import { type CoachApiGateway } from "@/modules/coach/gateway/coachApiGateway"
import {
  ProfessionalProfileDtoSchema,
  ProfessionalProfileInputDtoSchema,
  ProfessionalProfileUpdateDtoSchema,
  type ProfessionalProfileDto,
  type ProfessionalProfileInputDto,
  type ProfessionalProfileUpdateDto,
} from "@/modules/coach/gateway/coachDto"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { isAxiosError } from "axios"

export class CoachApi implements CoachApiGateway {
  private baseUrl = "/professional"

  constructor(private api: ApiClient) {}

  async getProfessionalProfile(id: string): Promise<ProfessionalProfileDto> {
    const result = await this.api.get<ProfessionalProfileDto>(`${this.baseUrl}/${id}`)
    return ProfessionalProfileDtoSchema.parse(result.data)
  }

  async getCurrentUserProfessionalProfile(): Promise<ProfessionalProfileDto | null> {
    try {
      const result = await this.api.get<ProfessionalProfileDto>(`${this.baseUrl}/user`)
      return result.status === 204 ? null : ProfessionalProfileDtoSchema.parse(result.data)
    } catch (error) {
      if (isAxiosError(error) && (!error.response || error.response.status === 404)) return null
      throw error
    }
  }

  async createProfessionalUser(input: ProfessionalProfileInputDto): Promise<ProfessionalProfileDto> {
    const result = await this.api.post<ProfessionalProfileDto>(
      this.baseUrl,
      ProfessionalProfileInputDtoSchema.parse(input),
    )
    return ProfessionalProfileDtoSchema.parse(result.data)
  }

  async updateProfessionalProfile(id: string, payload: ProfessionalProfileUpdateDto): Promise<ProfessionalProfileDto> {
    const result = await this.api.put<ProfessionalProfileDto>(
      `${this.baseUrl}/${id}`,
      ProfessionalProfileUpdateDtoSchema.parse(payload),
    )
    return ProfessionalProfileDtoSchema.parse(result.data)
  }

  async deleteProfessionalProfile(id: string): Promise<void> {
    await this.api.delete(`${this.baseUrl}/${id}`)
  }
}
